



















































































import { Component } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { getCateList, classEdit, classDel } from '@/api/admin'
import {
  clientGroupList,
  addClientGroup,
  editClientGroup,
  delClientGroup
} from './client.api'
import conFirm from './../confirm.vue'
import ClientGroupCreate from './clientGroupCreate.vue'
import TitleBack from '@/components/titleBack/titleBack.vue'

@Component({
  components: {
    conFirm,
    ClientGroupCreate,
    TitleBack
  }
})
export default class ClientGroup extends ViewBase {
  loading = true
  errMsg = ''
  total = 0
  page = 1
  pageSize = 10
  list = null
  editItem: any = {}
  delItem = {}
  editVisible = false
  delVisible = false
  title = ''
  resTypeList = []
  needStatus = ''
  phaseList = []
  subjectList = []
  dresType = {}
  dphase = {}
  dsubject = {}
  pagination: any = null
  columns: any = []
  lang = {}
  lang2: any = {}
  totalClass = 0
  isEdit: boolean = false

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  setColumns() {
    const lang: any = this.lang2
    this.columns = [
      {
        title: this.i18n.vStudentList.stuIndex,
        dataIndex: 'number'
      },
      {
        title: lang.clientGroup,
        dataIndex: 'client_group_name'
      },

      {
        title: lang.clientNum,
        dataIndex: 'count'
        // scopedSlots: { customRender: 'subjectid' }
      },
      {
        title: this.i18n.resource.operation,
        dataIndex: 'operation',
        className: 'texcenter wid400',
        scopedSlots: { customRender: 'operation' }
      }
    ]
  }
  created() {
    this.lang = this.i18n.vBinding
    this.lang2 = this.i18n.vClients
    this.fetch()
  }

  handleTableChange(pagination: any) {
    // console.log(pagination)
    const pager: any = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    this.fetch({
      page: pagination.current
    })
  }

  async fetch(params: any = {}) {
    // console.log('params:', params)
    this.loading = true

    try {
      const { data } = await clientGroupList(params)

      const pagination: any = { ...this.pagination }
      // Read total count from server
      // pagination.total = data.totalCount;
      pagination.total = data.total
      this.loading = false
      this.list = data.list
      this.totalClass = data.list ? data.list.length : 0
      this.pagination = pagination
      this.setColumns()
    } catch (ex) {
      this.handleError(ex)
    }
  }
  cancelMod() {
    this.editVisible = false
    this.delVisible = false
  }
  addclassshow() {
    this.isEdit = false
    this.editItem = {}
    this.editVisible = true
  }
  editclassshow(item: any) {
    this.isEdit = true
    const obj = Object.assign({}, item)
    obj.name = obj.name + ''
    this.editItem = obj
    this.editVisible = true
  }
  delclassshow(item: any) {
    this.delItem = item
    this.delVisible = true
  }
  toClientConfigList(item: any) {
    this.$router.push({
      name: 'clientConfigList',
      params: { id: item.client_group_id + '', group: item.client_group_name }
    })
  }
  async addclass(name: any) {
    const itme: any = this.editItem
    const pdata: any = {
      client_group_name: name + ''
    }
    if (this.isEdit) {
      pdata.client_group_id = this.editItem.client_group_id
    }
    try {
      let res: any = null
      if (this.isEdit) {
        res = await editClientGroup(pdata)
      } else {
        res = await addClientGroup(pdata)
      }
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      this.editVisible = false

      this.fetch({
        page: this.pagination.current || 1
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }
  async delclass() {
    const itme: any = this.delItem
    const pdata: any = {
      client_group_id: itme.client_group_id || ''
    }
    try {
      const res = await delClientGroup(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      this.delVisible = false
      let getPagination = 0
      if (this.totalClass == 1 && this.pagination.current != 1) {
        getPagination = this.pagination.current - 1
        this.pagination.current = getPagination
      } else if (this.totalClass > 1) {
        getPagination = this.pagination.current
      } else if (
        this.totalClass == 1 &&
        (!this.pagination.current || this.pagination.current == 1)
      ) {
        getPagination = 1
      }
      this.fetch({
        page: getPagination
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }
}
